"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.commonPermissions_en_us = void 0;
function commonPermissions_en_us() {
    return {
        "permissions.delete": "Remove all Permissions",
        "permissions.assign": "Assign standard permissions",
        "permissions.assigncustom": "Assign custom permissions",
        "permissions.errors.missing": "Missing permission '${permission}'",
        "permissions.audit.read.title": "read audit",
        "permissions.cms.write.title": "edit CMS pages",
        "permissions.cms.write.description": "This right allows to create, delete and edit CMS pages.",
        "permissions.cms.read.title": "read CMS pages",
        "permissions.cms.read.description": "This right allows to read CMS pages.",
        "permissions.checkin.admin.title": "checkin app admin",
        "permissions.checkin.admin.description": "This right allows to create, delete and edit checkin visitors, apps and configurations.",
        "permissions.checkin.read.title": "read checkin apps",
        "permissions.checkin.read.description": "This right allows to read checkin visitors, apps and configurations.",
        "permissions.custombackoffices.write.title": "edit custom backoffices",
        "permissions.custombackoffices.write.description": "This right allows to create, delete and edit custom backoffices.",
        "permissions.custombackoffices.read.title": "read custom backoffices",
        "permissions.custombackoffices.read.description": "This right allows to read custom backoffices.",
        "permissions.applications.read.title": "read Applications",
        "permissions.applications.read.description": "This right allows to read Applications.",
        "permissions.applications.write.title": "edit Applications",
        "permissions.applications.write.description": "This right allows to create, delete and edit Applications.",
        "permissions.bookedsubscriptions.write.title": "edit booked Subscriptions",
        "permissions.bookedsubscriptions.write.description": "This right allows to create, delete and edit booked Subscriptions.",
        "permissions.calendar.read.title": "read calendars",
        "permissions.calendar.read.description": "This right allows to read calendars.",
        "permissions.calendar.write.title": "edit calendars",
        "permissions.calendar.write.description": "This right allows to create, delete and edit Calendars.",
        "permissions.configuration.read.title": "read configurations",
        "permissions.configuration.read.description": "This right allows to read configurations.",
        "permissions.configuration.write.title": "edit configurations",
        "permissions.configuration.write.description": "This right allows to create, delete and edit configurations.",
        "permissions.configuration.admin.title": "configuration admin",
        "permissions.configuration.admin.description": "This right grants full access to all configration operations.",
        "permissions.contacts.read.title": "read contacts",
        "permissions.contacts.read.description": "This right allows to read contacts.",
        "permissions.contacts.write.title": "edit contacts",
        "permissions.contacts.write.description": "This right allows to create, delete and edit contacts.",
        "permissions.contacts.admin.title": "contact admin",
        "permissions.contacts.admin.description": "This right grants full access to all contact operations.",
        "permissions.cronjob.read.title": "read cronjobs",
        "permissions.cronjob.read.description": "This right allows to read cronjobs.",
        "permissions.cronjob.write.title": "edit cronjobs",
        "permissions.cronjob.write.description": "This right allows to create, delete and edit cronjobs.",
        "permissions.data.read.title": "read data",
        "permissions.data.read.description": "This right allows to read data.",
        "permissions.data.write.title": "edit data",
        "permissions.data.write.description": "This right allows to create, delete and edit data.",
        "permissions.datatypes.read.title": "read datatypes",
        "permissions.datatypes.read.description": "This right allows to read project datatypes.",
        "permissions.datatypes.write.title": "edit project datatypes",
        "permissions.datatypes.write.description": "This right allows to create, delete and edit datatypes.",
        "permissions.devices.read.title": "read devices",
        "permissions.devices.read.description": "This right allows to read devices.",
        "permissions.devices.write.title": "edit devices",
        "permissions.devices.write.description": "This right allows to create, delete and edit devices.",
        "permissions.emails.read.title": "read emails",
        "permissions.emails.read.description": "This right allows to read emails.",
        "permissions.emails.write.title": "write emails",
        "permissions.emails.write.description": "This right allows to create, delete and edit emails.",
        "permissions.emails.send.title": "send emails",
        "permissions.emails.send.description": "This right allows to send emails.",
        "permissions.emailtemplates.read.title": "read email templates",
        "permissions.emailtemplates.read.description": "This right allows to read email templates.",
        "permissions.emailtemplates.write.title": "edit email templates",
        "permissions.emailtemplates.write.description": "This right allows to create, delete and edit email templates.",
        "permissions.exporters.execute.title": "execute exporters",
        "permissions.exporters.execute.description": "This right allows to execute exporters.",
        "permissions.exporters.read.title": "read exporters",
        "permissions.exporters.read.description": "This right allows to read exporters.",
        "permissions.files.read.title": "read project files",
        "permissions.files.read.description": "This right allows to read project files.",
        "permissions.files.write.title": "edit project files",
        "permissions.files.write.description": "This right allows to create, delete and edit project files.",
        "permissions.forms.read.title": "read forms",
        "permissions.forms.read.description": "This right allows to read forms.",
        "permissions.forms.write.title": "edit forms",
        "permissions.forms.write.description": "This right allows to create, delete and edit forms.",
        "permissions.forms.admin.title": "forms admin",
        "permissions.forms.admin.description": "This right grants full access to all form operations.",
        "permissions.importers.execute.title": "execute importers",
        "permissions.importers.execute.description": "This right allows to execute importers.",
        "permissions.importers.read.title": "read importers",
        "permissions.importers.read.description": "This right allows to read importers.",
        "permissions.internationalization.read.title": "read internationalizations",
        "permissions.internationalization.read.description": "This right allows to read internationalizations.",
        "permissions.internationalization.write.title": "edit internationalizations",
        "permissions.internationalization.write.description": "This right allows to create, delete and edit internationalizations.",
        "permissions.messages.read.title": "read messages",
        "permissions.messages.read.description": "This right allows to read messages.",
        "permissions.messages.write.title": "edit messages",
        "permissions.messages.write.description": "This right allows to create, delete and edit messages.",
        "permissions.mailinglist.read.title": "read mailing lists",
        "permissions.mailinglist.read.description": "This right allows to read mailing lists.",
        "permissions.mailinglist.write.title": "edit mailing lists",
        "permissions.mailinglist.write.description": "This right allows to create, delete and edit mailing lists.",
        "permissions.mailingchannel.read.title": "read mailing channels",
        "permissions.mailingchannel.read.description": "This right allows to read mailing channels.",
        "permissions.mailingchannel.write.title": "edit mailing channels",
        "permissions.mailingchannel.write.description": "This right allows to create, delete and edit mailing channels.",
        "permissions.mailingdeliverable.read.title": "read mailing deliverables",
        "permissions.mailingdeliverable.read.description": "This right allows to read mailing deliverables.",
        "permissions.mailingdeliverable.write.title": "edit mailing deliverables",
        "permissions.mailingdeliverable.write.description": "This right allows to create, delete and edit mailing deliverables.",
        "permissions.optin.write.title": "edit optins",
        "permissions.optin.write.description": "This right allows to create, delete and edit optins.",
        "permissions.orders.read.title": "read orders",
        "permissions.orders.read.description": "This right allows to read orders.",
        "permissions.orders.write.title": "edit orders",
        "permissions.orders.write.description": "This right allows to create, delete and edit orders.",
        "permissions.permission.read.title": "read permissions",
        "permissions.permission.read.description": "This right allows to read permissions.",
        "permissions.permission.write.title": "edit permissions",
        "permissions.permission.write.description": "This right allows to create, delete and edit permissions.",
        "permissions.products.read.title": "read products",
        "permissions.products.read.description": "This right allows to read products.",
        "permissions.products.write.title": "edit products",
        "permissions.products.write.description": "This right allows to create, delete and edit products.",
        "permissions.datatemplates.write.title": "edit data templates",
        "permissions.datatemplates.write.description": "This right allows to create, delete and edit data templates.",
        "permissions.shoppingcarts.read.title": "read shopping carts",
        "permissions.shoppingcarts.read.description": "This right allows to read shopping carts.",
        "permissions.shoppingcarts.write.title": "edit shopping carts",
        "permissions.shoppingcarts.write.description": "This right allows to create, delete and edit shopping carts.",
        "permissions.suppliers.read.title": "read suppliers",
        "permissions.suppliers.read.description": "This right allows to read suppliers.",
        "permissions.suppliers.write.title": "edit suppliers",
        "permissions.suppliers.write.description": "This right allows to create, delete and edit suppliers.",
        "permissions.tasks.execute.title": "execute tasks",
        "permissions.tasks.execute.description": "This right allows to execute tasks",
        "permissions.tasks.read.title": "read tasks",
        "permissions.tasks.read.description": "This right allows to read tasks.",
        "permissions.tasks.write.title": "edit tasks",
        "permissions.tasks.write.description": "This right allows to create, delete and edit tasks.",
        "permissions.tenant.admin.title": "admin",
        "permissions.tenant.admin.description": "This right grants full access to all data and modules of a project.",
        "permissions.tenant.read.title": "read tenants (projects/companies)",
        "permissions.tenant.read.description": "This right allows to read tenants (projects/companies).",
        "permissions.tenant.write.title": "edit tenants (projects/companies)",
        "permissions.tenant.write.description": "This right allows to create, delete and edit tenants (projects/companies).",
        "permissions.company.read.title": "read company",
        "permissions.company.read.description": "This right allows to read the company.",
        "permissions.company.write.title": "edit company",
        "permissions.company.write.description": "This right allows to delete and edit the company.",
        "permissions.project.read.title": "read project",
        "permissions.project.read.description": "This right allows to read the project.",
        "permissions.project.write.title": "edit project",
        "permissions.project.write.description": "This right allows to delete and edit the project.",
        "permissions.users.read.title": "read users",
        "permissions.users.read.description": "This right allows to read users.",
        "permissions.users.write.title": "edit users",
        "permissions.users.write.description": "This right allows to create, delete and edit users.",
        "permissions.workflow.execute.title": "execute workflows",
        "permissions.workflow.execute.description": "This right allows to execute Workflows.",
        "permissions.workflow.read.title": "read workflows",
        "permissions.workflow.read.description": "This right allows to read workflows.",
        "permissions.workflow.write.title": "edit workflows",
        "permissions.workflow.write.description": "This right allows to create, delete and edit workflows.",
        "permissions.todotemplate.write": "edit todo-templates"
    };
}
exports.commonPermissions_en_us = commonPermissions_en_us;
